export default __webpack_public_path__ + "7866e613a49c470ae9687456b3e5585e.svg";